(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["all-crates"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('wholesale-lineup')) {
    customElements.define(
      'wholesale-lineup',
      class extends HTMLElement {
        connectedCallback() {
          this.abort?.abort();
          this.abort = new AbortController();
          const opts = { signal: this.abort.signal };
          this.tabs = [...this.querySelectorAll('.wh-tab')];
          this.panels = [...this.querySelectorAll('[data-panel]')];
          this.dots = [...this.querySelectorAll('.wh-lineup-dot')];
          this.querySelector('[data-dots]').hidden = this.panels.length < 2;
          this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.select(i), opts));
          if (!this.tabs.length) return;
          const tablist = this.querySelector('[data-tabs]');
          tablist.hidden = false;
          tablist.setAttribute('role', 'tablist');
          this.querySelector('[data-controls]').hidden = this.tabs.length < 2;
          this.tabs.forEach((tab, i) => {
            tab.setAttribute('role', 'tab');
            this.panels[i].setAttribute('role', 'tabpanel');
            this.panels[i].setAttribute('aria-labelledby', tab.id);
            this.panels[i].tabIndex = 0;
            tab.addEventListener('click', () => this.select(i), opts);
            tab.addEventListener(
              'keydown',
              (event) => {
                const moves = { ArrowRight: 1, ArrowLeft: -1 };
                let index;
                if (event.key in moves) index = (i + moves[event.key] + this.tabs.length) % this.tabs.length;
                else if (event.key === 'Home') index = 0;
                else if (event.key === 'End') index = this.tabs.length - 1;
                else return;
                event.preventDefault();
                this.select(index, true);
              },
              opts,
            );
          });
          this.querySelectorAll('[data-direction]').forEach((button) =>
            button.addEventListener(
              'click',
              () =>
                this.select(
                  (this.index + Number(button.dataset.direction) + this.tabs.length) % this.tabs.length,
                  true,
                ),
              opts,
            ),
          );
          document.addEventListener(
            'shopify:block:select',
            (event) => {
              const i = this.panels.findIndex((panel) => panel.dataset.blockId === event.detail.blockId);
              if (i >= 0) this.select(i);
            },
            opts,
          );
          this.track = this.querySelector('[data-track]');
          this.mobile = window.matchMedia('(max-width: 767px)');
          this.classList.add('is-initialized');
          this.mobile.addEventListener('change', () => this.select(this.index), opts);
          let scrollFrame;
          this.track.addEventListener(
            'scroll',
            () => {
              if (!this.mobile.matches || scrollFrame) return;
              scrollFrame = requestAnimationFrame(() => {
                scrollFrame = null;
                if (!this.isConnected) return;
                const left = this.track.getBoundingClientRect().left;
                const nearest = this.panels.reduce(
                  (best, panel, i) =>
                    Math.abs(panel.getBoundingClientRect().left - left) <
                    Math.abs(this.panels[best].getBoundingClientRect().left - left)
                      ? i
                      : best,
                  0,
                );
                if (nearest !== this.index) this.select(nearest, false, false);
              });
            },
            opts,
          );
          this.select(0);
        }
        select(index, focus = false, scroll = true) {
          this.index = index;
          this.dots.forEach((dot, i) => {
            dot.classList.toggle('is-active', i === index);
            if (i === index) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          this.tabs.forEach((tab, i) => {
            tab.setAttribute('aria-selected', String(i === index));
            tab.tabIndex = i === index ? 0 : -1;
            this.panels[i].hidden = !this.mobile?.matches && i !== index;
            this.panels[i].inert = i !== index;
          });
          if (this.mobile?.matches) {
            if (scroll) {
              this.track.scrollLeft +=
                this.panels[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left;
            }
            const tab = this.tabs[index];
            const tablist = tab.parentElement;
            const delta = tab.getBoundingClientRect().left - tablist.getBoundingClientRect().left;
            if (delta < 0) tablist.scrollLeft += delta;
            else if (delta + tab.offsetWidth > tablist.clientWidth)
              tablist.scrollLeft += delta + tab.offsetWidth - tablist.clientWidth;
          }
          if (focus) this.tabs[index].focus({ preventScroll: this.mobile?.matches });
        }
        disconnectedCallback() {
          this.abort?.abort();
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["explore-faq-advanced"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('explore-faq-advanced')) {
    customElements.define(
      'explore-faq-advanced',
      class extends HTMLElement {
        connectedCallback() {
          this.onBlockSelect = (event) => {
            const details = event.target.closest('details');
            if (details && this.contains(details)) details.open = true;
          };
          this.addEventListener('shopify:block:select', this.onBlockSelect);
        }
        disconnectedCallback() {
          this.removeEventListener('shopify:block:select', this.onBlockSelect);
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["explore-value-props"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('explore-value-cards')) {
    customElements.define(
      'explore-value-cards',
      class extends HTMLElement {
        connectedCallback() {
          this.style.display = 'block';
          this.observer?.disconnect();
          const cards = [...this.querySelectorAll('.explore-value')];
          const align = () => {
            if (!this.isConnected) return;
            const rows = new Map();
            const selectors = [
              '.explore-value__content',
              '.explore-value__content h3',
              '.explore-value__content > .rte',
            ];
            cards.forEach((card) =>
              selectors.forEach((selector) => {
                const element = card.querySelector(selector);
                if (element) element.style.minHeight = '';
              }),
            );
            cards.forEach((card) => {
              const top = Math.round(card.offsetTop);
              if (!rows.has(top)) rows.set(top, []);
              rows.get(top).push(card);
            });
            rows.forEach((row) => {
              if (row.length < 2) return;
              // Equalize text rows first, then the full content stack (including icons).
              [...selectors.slice(1), selectors[0]].forEach((selector) => {
                const elements = row.map((card) => card.querySelector(selector)).filter(Boolean);
                const height = Math.max(0, ...elements.map((element) => element.getBoundingClientRect().height));
                elements.forEach((element) => (element.style.minHeight = `${height}px`));
              });
            });
          };
          this.observer = new ResizeObserver((entries) => {
            const widths = entries.map((entry) => entry.contentRect.width).join(',');
            if (widths === this.widths) return;
            this.widths = widths;
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(align);
          });
          cards.forEach((card) => this.observer.observe(card));
          document.fonts.ready.then(() => {
            if (this.isConnected) align();
          });
          align();
        }
        disconnectedCallback() {
          this.observer?.disconnect();
          cancelAnimationFrame(this.frame);
          this.widths = null;
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["explore-video-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('explore-videos')) {
    customElements.define(
      'explore-videos',
      class extends HTMLElement {
        connectedCallback() {
          this.abort?.abort();
          this.observer?.disconnect();
          this.abort = new AbortController();
          const options = { signal: this.abort.signal };
          const track = this.querySelector('[data-video-track]');
          const controls = this.querySelector('[data-video-controls]');
          const buttons = [...controls.querySelectorAll('button')];
          const cards = [...track.querySelectorAll('.explore-video-card')];
          const dotsWrap = this.querySelector('[data-video-dots]');
          const dots = [...dotsWrap.querySelectorAll('button')];
          dots.forEach((dot, i) =>
            dot.addEventListener(
              'click',
              () => {
                track.scrollTo({
                  left: cards[i].offsetLeft - cards[0].offsetLeft,
                  behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
                });
              },
              options,
            ),
          );
          const update = () => {
            const overflow = track.scrollWidth > track.clientWidth + 2;
            controls.hidden = !overflow;
            dotsWrap.hidden = !overflow || cards.length < 2;
            let active = 0;
            if (overflow && track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) active = cards.length - 1;
            else
              cards.forEach((card, i) => {
                if (
                  Math.abs(card.offsetLeft - cards[0].offsetLeft - track.scrollLeft) <
                  Math.abs(cards[active].offsetLeft - cards[0].offsetLeft - track.scrollLeft)
                )
                  active = i;
              });
            dots.forEach((dot, i) => {
              dot.classList.toggle('is-active', i === active);
              if (i === active) dot.setAttribute('aria-current', 'true');
              else dot.removeAttribute('aria-current');
            });
            buttons[0].disabled = track.scrollLeft <= 2;
            buttons[1].disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
          };
          buttons.forEach((button) =>
            button.addEventListener(
              'click',
              () => {
                const card = track.querySelector('.explore-video-card');
                if (!card) return;
                const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
                track.scrollBy({
                  left: distance * Number(button.dataset.direction),
                  behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
                });
              },
              options,
            ),
          );
          track.addEventListener('scroll', update, options);
          cards.forEach((card) => {
            const video = card.querySelector('video');
            const play = card.querySelector('[data-video-play]');
            if (!video || !play) return;
            if (!video.dataset.exploreInitialized) {
              video.controls = false;
              video.dataset.exploreInitialized = 'true';
              play.hidden = false;
            }
            play.addEventListener(
              'click',
              async () => {
                video.controls = true;
                play.hidden = true;
                video.tabIndex = 0;
                video.focus({ preventScroll: true });
                try {
                  await video.play();
                } catch {
                  video.controls = true;
                }
              },
              options,
            );
          });
          this.querySelectorAll('video').forEach((video) =>
            video.addEventListener(
              'play',
              () => {
                this.querySelectorAll('video').forEach((other) => {
                  if (other !== video) other.pause();
                });
              },
              options,
            ),
          );
          document.addEventListener(
            'shopify:block:select',
            (event) => {
              if (event.target instanceof Element && !this.contains(event.target)) return;
              const card = [...track.children].find((el) => el.dataset.blockId === event.detail?.blockId);
              if (card) track.scrollLeft = card.offsetLeft - track.firstElementChild.offsetLeft;
            },
            options,
          );
          this.observer = new ResizeObserver(update);
          this.observer.observe(track);
          update();
        }
        disconnectedCallback() {
          this.abort?.abort();
          this.observer?.disconnect();
          this.querySelectorAll('video').forEach((video) => video.pause());
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["explore-video-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('explore-video-grid')) {
    customElements.define(
      'explore-video-grid',
      class extends HTMLElement {
        connectedCallback() {
          this.abort?.abort();
          this.observer?.disconnect();
          this.abort = new AbortController();
          const options = { signal: this.abort.signal };
          const track = this.querySelector('[data-video-track]');
          const controls = this.querySelector('[data-video-controls]');
          const buttons = [...controls.querySelectorAll('button')];
          const cards = [...track.querySelectorAll('.explore-video-card')];
          const dotsWrap = this.querySelector('[data-video-dots]');
          const dots = [...dotsWrap.querySelectorAll('button')];
          dots.forEach((dot, i) =>
            dot.addEventListener(
              'click',
              () => {
                track.scrollTo({
                  left: cards[i].offsetLeft - cards[0].offsetLeft,
                  behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
                });
              },
              options,
            ),
          );
          const update = () => {
            const overflow = track.scrollWidth > track.clientWidth + 2;
            controls.hidden = !overflow;
            dotsWrap.hidden = !overflow || cards.length < 2;
            let active = 0;
            if (overflow && track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) active = cards.length - 1;
            else
              cards.forEach((card, i) => {
                if (
                  Math.abs(card.offsetLeft - cards[0].offsetLeft - track.scrollLeft) <
                  Math.abs(cards[active].offsetLeft - cards[0].offsetLeft - track.scrollLeft)
                )
                  active = i;
              });
            dots.forEach((dot, i) => {
              dot.classList.toggle('is-active', i === active);
              if (i === active) dot.setAttribute('aria-current', 'true');
              else dot.removeAttribute('aria-current');
            });
            buttons[0].disabled = track.scrollLeft <= 2;
            buttons[1].disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
          };
          buttons.forEach((button) =>
            button.addEventListener(
              'click',
              () => {
                const card = track.querySelector('.explore-video-card');
                if (!card) return;
                const distance = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
                track.scrollBy({
                  left: distance * Number(button.dataset.direction),
                  behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
                });
              },
              options,
            ),
          );
          track.addEventListener('scroll', update, options);
          cards.forEach((card) => {
            const video = card.querySelector('video');
            const play = card.querySelector('[data-video-play]');
            if (!video || !play) return;
            if (!video.dataset.exploreInitialized) {
              video.controls = false;
              video.dataset.exploreInitialized = 'true';
              play.hidden = false;
            }
            play.addEventListener(
              'click',
              async () => {
                video.controls = true;
                play.hidden = true;
                video.tabIndex = 0;
                video.focus({ preventScroll: true });
                try {
                  await video.play();
                } catch {
                  video.controls = true;
                }
              },
              options,
            );
          });
          this.querySelectorAll('video').forEach((video) =>
            video.addEventListener(
              'play',
              () => {
                this.querySelectorAll('video').forEach((other) => {
                  if (other !== video) other.pause();
                });
              },
              options,
            ),
          );
          document.addEventListener(
            'shopify:block:select',
            (event) => {
              if (event.target instanceof Element && !this.contains(event.target)) return;
              const card = [...track.children].find((el) => el.dataset.blockId === event.detail?.blockId);
              if (card) track.scrollLeft = card.offsetLeft - track.firstElementChild.offsetLeft;
            },
            options,
          );
          this.observer = new ResizeObserver(update);
          this.observer.observe(track);
          update();
        }
        disconnectedCallback() {
          this.abort?.abort();
          this.observer?.disconnect();
          this.querySelectorAll('video').forEach((video) => video.pause());
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["food-ingredients-toggle"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('impact-food-ingredients')) {
  customElements.define('impact-food-ingredients', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.buttons = [...this.querySelectorAll('[data-recipe]')];
      this.panels = [...this.querySelectorAll('[data-recipe-panel]')];
      this.querySelector('[data-recipe-toggle]')?.removeAttribute('hidden');
      this.buttons.forEach(button => button.addEventListener('click', () => this.select(button.dataset.recipe), options));
      if (this.panels.length) this.select(this.panels[0].dataset.recipePanel);
      this.querySelectorAll('[data-label-open]').forEach(button => {
        const dialog = this.querySelector(`#${CSS.escape(button.getAttribute('aria-controls'))}`);
        if (!dialog || typeof dialog.showModal !== 'function') return;
        button.hidden = false;
        button.addEventListener('click', () => { this.opener = button; dialog.showModal(); }, options);
        dialog.addEventListener('close', () => { if (this.opener?.isConnected) this.opener.focus(); }, options);
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }, options);
      });
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-recipe-panel]');
        if (panel) this.select(panel.dataset.recipePanel);
      }, options);
    }
    select(id) {
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.recipe === id)));
      this.panels.forEach(panel => {
        panel.hidden = panel.dataset.recipePanel !== id;
        if (panel.hidden) panel.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-signup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const state = window.impactWholesaleTracking = window.impactWholesaleTracking || {
      sent: new Map(), initialized: new WeakSet(), configured: new Set(), privacyLoading: false
    };
    const sentKey = 'impact-wholesale-leads-v1';
    const pendingLifetime = 10 * 60 * 1000;
    const sentLifetime = 24 * 60 * 60 * 1000;

    function readStorage(key) {
      try { return JSON.parse(window.sessionStorage.getItem(key)); } catch (_) { return null; }
    }
    function removeStorage(key) {
      try { window.sessionStorage.removeItem(key); } catch (_) { /* Storage can be disabled. */ }
    }
    function writeStorage(key, value) {
      try { window.sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) { /* In-page dedupe still works. */ }
    }
    const saved = readStorage(sentKey);
    if (Array.isArray(saved)) {
      saved.slice(-100).forEach((entry) => {
        if (!Array.isArray(entry)) return;
        const [key, timestamp] = entry;
        if (typeof key === 'string' && Number.isFinite(timestamp) && Date.now() >= timestamp && Date.now() - timestamp < sentLifetime) {
          state.sent.set(key, timestamp);
        }
      });
    }

    function trackingAllowed() {
      if (window.Shopify?.designMode) return false;
      const privacy = window.Shopify?.customerPrivacy;
      if (!privacy) return false;
      try {
        const marketing = typeof privacy.marketingAllowed === 'function'
          ? privacy.marketingAllowed()
          : typeof privacy.userCanBeTracked === 'function' && privacy.userCanBeTracked();
        const sharing = typeof privacy.saleOfDataAllowed === 'function'
          ? privacy.saleOfDataAllowed()
          : typeof privacy.userDataCanBeSold === 'function' && privacy.userDataCanBeSold();
        return Boolean(marketing && sharing);
      } catch (_) { return false; }
    }

    function remember(key) {
      state.sent.set(key, Date.now());
      state.sent.forEach((timestamp, id) => {
        if (Date.now() - timestamp >= sentLifetime) state.sent.delete(id);
      });
      while (state.sent.size > 100) state.sent.delete(state.sent.keys().next().value);
      writeStorage(sentKey, Array.from(state.sent));
    }

    function googleDestination(root) {
      const destination = root?.dataset.wholesaleGoogleSendTo || '';
      return /^AW-\d+\/[A-Za-z0-9_-]+$/.test(destination) ? destination : '';
    }

    function prepareGoogle(root) {
      const destination = googleDestination(root);
      if (!destination || !trackingAllowed()) return false;
      const tagId = destination.split('/')[0];
      try {
        window.dataLayer = window.dataLayer || [];
        const library = document.querySelector('script[src*="googletagmanager.com/gtag/js"]');
        if (typeof window.gtag !== 'function') {
          window.gtag = function () { window.dataLayer.push(arguments); };
        }
        if (!library) {
          const script = document.createElement('script');
          script.src = 'https://www.googletagmanager.com/gtag/js?id=' + tagId;
          script.async = true;
          script.dataset.wholesaleGoogleTag = 'true';
          window.gtag('js', new Date());
          document.head.append(script);
        }
        const alreadyConfigured = window.dataLayer.some((command) => command?.[0] === 'config' && command[1] === tagId);
        if (!state.configured.has(tagId) && !alreadyConfigured) {
          window.gtag('config', tagId, { send_page_view: false });
        }
        state.configured.add(tagId);
        return true;
      } catch (_) { return false; }
    }

    function trackLead(root, submissionId) {
      if (!root || !submissionId || !trackingAllowed()) return;
      const metaKey = 'meta:' + submissionId;
      if (!state.sent.has(metaKey) && typeof window.fbq === 'function') {
        try {
          window.fbq('track', 'Lead', {
            content_name: 'Wholesale Application', content_category: 'Wholesale', form_type: 'wholesale'
          }, { eventID: submissionId });
          remember(metaKey);
        } catch (_) { /* One vendor must not block the other or the application. */ }
      }
      const destination = googleDestination(root);
      const googleKey = 'google:' + destination + ':' + submissionId;
      if (destination && !state.sent.has(googleKey) && prepareGoogle(root)) {
        try {
          window.gtag('event', 'conversion', { send_to: destination, transaction_id: submissionId });
          remember(googleKey);
        } catch (_) { /* Successful form submission remains successful. */ }
      }
    }

    function typeformSubmitted(response) {
      const responseId = response?.responseId;
      if (typeof responseId !== 'string' || !/^[A-Za-z0-9_-]{1,200}$/.test(responseId)) return;
      if (!window.Shopify?.customerPrivacy && !window.Shopify?.designMode) {
        const queue = window.impactWholesaleTypeformSubmissions = window.impactWholesaleTypeformSubmissions || [];
        if (queue.length < 10) queue.push({ responseId, createdAt: Date.now() });
        return;
      }
      const embed = document.querySelector('[data-wholesale-signup] .wh-typeform[data-tf-on-submit="impactWholesaleTypeformSubmitted"]');
      // The live embed ID is not Typeform's formId. The dedicated callback scopes this to wholesale.
      trackLead(embed?.closest('[data-wholesale-signup]'), 'wholesale-typeform-' + responseId);
    }
    // Keep the dispatcher's identity: an already-loaded SDK may have retained it.
    window.impactWholesaleHandleTypeformSubmit = typeformSubmitted;

    function finishTypeformSubmissions() {
      if (!window.Shopify?.customerPrivacy) return;
      const queue = window.impactWholesaleTypeformSubmissions || [];
      window.impactWholesaleTypeformSubmissions = [];
      queue.forEach((response) => {
        if (Date.now() >= response.createdAt && Date.now() - response.createdAt < pendingLifetime) typeformSubmitted(response);
      });
    }

    function pendingKey(root) {
      return 'impact-wholesale-pending:' + root.dataset.wholesaleSectionId + ':' + window.location.pathname;
    }
    function finishNativeSuccess(root) {
      if (!root.querySelector('[data-wholesale-success]') || !window.Shopify?.customerPrivacy) return;
      const key = pendingKey(root);
      const pending = readStorage(key);
      removeStorage(key);
      if (
        pending && typeof pending.id === 'string' && Number.isFinite(pending.createdAt) &&
        Date.now() >= pending.createdAt && Date.now() - pending.createdAt < pendingLifetime
      ) trackLead(root, pending.id);
    }

    function initializeWholesaleSignup(root) {
      const application = document.querySelector('.wh-signup[id]');
      if (application) {
        document.querySelectorAll('[data-wholesale-apply]').forEach((link) => {
          link.setAttribute('href', '#' + application.id);
        });
      }
      const signup = root.matches?.('[data-wholesale-signup]') ? root : root.querySelector?.('[data-wholesale-signup]');
      if (signup) {
        prepareGoogle(signup);
        if (signup.querySelector('[data-wholesale-error]')) removeStorage(pendingKey(signup));
        finishNativeSuccess(signup);
        const form = signup.querySelector('.wh-form');
        if (form && !state.initialized.has(form)) {
          state.initialized.add(form);
          form.addEventListener('submit', () => {
            if (window.Shopify?.designMode || !form.checkValidity()) return;
            const token = window.crypto?.randomUUID?.() || Date.now() + '-' + Math.random().toString(36).slice(2);
            writeStorage(pendingKey(signup), { id: 'wholesale-native-' + token, createdAt: Date.now() });
          });
        }
      }
      const embed = root.querySelector?.('.wh-typeform');
      if (embed && typeof window.tf?.load === 'function') window.tf.load();
      if (
        embed &&
        !document.querySelector('script[data-wholesale-typeform]') &&
        !document.querySelector('script[src*="embed.typeform.com/next/embed.js"]')
      ) {
        const script = document.createElement('script');
        script.src = 'https://embed.typeform.com/next/embed.js';
        script.async = true;
        script.dataset.wholesaleTypeform = 'true';
        document.head.append(script);
      }
      const result = root.querySelector?.('[data-form-result]');
      if (result) result.focus();
    }
    initializeWholesaleSignup(document);
    finishTypeformSubmissions();
    if (!state.listening) {
      state.listening = true;
      document.addEventListener('shopify:section:load', (event) => initializeWholesaleSignup(event.target));
      document.addEventListener('visitorConsentCollected', () => {
        finishTypeformSubmissions();
        document.querySelectorAll('[data-wholesale-signup]').forEach((signup) => {
          prepareGoogle(signup);
          finishNativeSuccess(signup);
        });
      });
    }
    if (!window.Shopify?.customerPrivacy && !state.privacyLoading && typeof window.Shopify?.loadFeatures === 'function') {
      state.privacyLoading = true;
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
          state.privacyLoading = false;
          if (!error) {
            finishTypeformSubmissions();
            document.querySelectorAll('[data-wholesale-signup]').forEach((signup) => {
              prepareGoogle(signup);
              finishNativeSuccess(signup);
            });
          }
        });
      } catch (_) { state.privacyLoading = false; }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
